export const baseURL = 'https://tracker.visualizenews.com';
export const summaryURL = `${baseURL}/summary`;
export const yesterdayURL = `${baseURL}/yesterday`;
export const sourcesURL = `${baseURL}/sources`;
export const overviewURL = `${baseURL}/overview`;
export const calendarURL = `${baseURL}/calendar`;
export const topicsURL = `${baseURL}/keywords`;
export const relationsURL = `${baseURL}/relations`;

export const footerLegalURL = 'https://visualize.news/remotes/footer/legal_it.html';
export const footerCorporateURL = 'https://visualize.news/remotes/footer/corporate_it.html';

export const colors = {
  neutral: 'var(--neutral)',
  positive: 'var(--positive)',
  negative: 'var(--negative)',
};

export const topics = [
  {
    title: 'La guerra in Ucraina',
    description: '<p>Sono più di due anni che continuano i combattimenti in Ucraina: quanto i protagonisti e i luoghi di questo conflitto sono citati assieme alle nostre protagoniste?</p>',
    id: 'ucraina',
    queries: [
      {
        query: 'ucraina',
        keys: ['ucraina', 'russia', 'putin', 'zelensky', 'zelenskyy', 'kiev', 'donbass']
      }
    ]
  },
  {
    title: 'La situazione in Medio Oriente',
    description: '<p>Il 7 ottobre 2023 un commando di Hamas compie un attacco senza precedenti contro Israele. La risposta è immediata e spietata, a distanza di mesi l\'esercito israeliano sta continuando le sue operazioni a Gaza, causando una crisi umanitaria senza precedenti e facendo scattare diverse rappresaglie, la più discussa quella degli Houti nel Mar Rosso.</p>',
    id: 'gaza',
    queries: [
      {
        title: 'Gaza, Israele e Medio Oriente',
        query: 'gaza',
        keys: ['gaza', 'israele', 'hamas', 'netanyahu', 'bibi', 'haniyeh', 'cisgiordania', 'libano', 'giordania', 'iran', 'egitto', 'palestina', 'siria', 'abu mazen', 'mahmud abbas', 'mazen', 'abbas']
      },
      {
        title: 'Houthi e Mar Rosso',
        query: 'houthi',
        keys: ['houthi', 'houti', 'mar rosso', 'marina', 'nave', 'navi', 'caio duilio', 'yemen']
      }
    ]
  },
  {
    title: 'I rapporti con l\'UE',
    description: '<p>L\'attuale governo italiano è composto da molti partiti definiti "euroscettici". Quanto spazio hanno le discussioni su e con l\'UE sui nostri giornali?</p>',
    id: 'ue',
    queries: [
      {
        query: 'ue',
        keys: ['ue', 'europa', 'bruxelles', 'von der leyen', 'metsola', 'sassoli', 'kaili', 'michel', 'borrell', 'montser', 'consiglio europeo', 'parlamento europeo']
      }
    ]
  },
  {
    title: 'I rapporti con l\'Ungheria',
    description: '<p>Viktor Orbán è uno dei politici di cui si parla di più a livello europeo. Il suo partito fa parte, a Bruxelles, dello stesso gruppo parlamentare di Fratelli d\'Italia. E le sue posizioni su diritti civili e guerra in Ucraina sono sempre fonte di polemiche. Quest\'anno poi è esploso il "caso Salis" che ha portato i giornali italiani a spendere ancora più parole sull\'Ungheria.</p>',
    id: 'ungheria',
    queries: [
      {
        query: 'ungheria',
        keys: ['ungheria', 'orban', 'orbán'],
        title: 'L\'Ungheria e Orban',
        description: '',
      },
      {
        query: 'salis',
        keys: ['salis', 'varga', 'tuzson', 'szijjártó', 'szijjarto'],
        title: 'Il Caso Salis',
      },
    ],
  },
  {
    title: 'Le presidenziali americane',
    description: '<p>A novembre 2024 si terranno le presidenziali americane; la campagna elettorale è già iniziata, e i risultati delle primarie scontati: a sfidarsi saranno molto probabilmente il presidente uscente Biden e l\'ex presidente Trump.</p>',
    id: 'ucraina',
    queries: [
      {
        query: 'elezioniUsa',
        keys: ['biden', 'trump', 'primarie']
      }
    ]
  },
  {
    title: 'I rapporti con l\'Egitto di Al Sisi',
    description: '<p>Nel gennaio 2016 al Cairo venne rapito e poi ucciso Giulio Regeni, dottorando dell\'università inglese di Cambridge. Le indagini sono state lunghe e difficili, soprattutto per la mancata collaborazione delle autorità egiziane. Nel febbraio 2024, a Roma, inizia il processo ai quattro agenti dei servizi segreti egiziani accusati dell\'omicidio.</p>',
    id: 'regezi',
    queries: [
      {
        query: 'regeni',
        keys: ['regeni', 'giulio regeni', 'egitto', 'al sisi']
      }
    ]
  },
];

export const debounce = (func, delay) => {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const reduceData = (person, radius, content, total) => {
  const sentiments = Object.keys(colors);
  const tmp = [];
  content.data[person].forEach((d) => {
    tmp.push({
      sentiment: d.meta_sentiment,
      val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(d.count / total),
      v: d.count,
      w: radius(d.count / total),
      c: colors[d.meta_sentiment],
    });
  });
  if (tmp.length < 3) {
    sentiments.forEach((s) => {
      if (!tmp.find(m => m.sentiment === s)) {
        tmp.push({
          sentiment: s,
          val: new Intl.NumberFormat('it-IT', { style: 'percent' }).format(0),
          v: 0,
          w: radius(0),
          c: colors[s],
        });
      }
    });
  }
  return tmp.sort((a, b) => b.v - a.v);
};

export const getStickerSize = () => {
  let maxSize = 160;
  let minSize = 60;
  if (window.matchMedia('screen and (min-width: 768px)').matches) {
    maxSize = 350;
    minSize = 80;
  }
  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    maxSize = 260;
    minSize = 60;
  }
  return [minSize, maxSize];
};

export const getChartSizes = (numberOfItems, width) => {
  let margins = {
    top: 48,
    right: 0,
    bottom: 48,
    left: 0,
  };
  let lineSize = Math.floor((width - margins.right - margins.top) / numberOfItems);
  let barSize = lineSize - 1;
  let axisSize = 20;
  let seriesSize = 100;
  let height = 220 + margins.top + margins.bottom;
  let orientation = 'horizontal';
  // if (window.matchMedia('screen and (min-width: 768px)').matches) {
  //   lineSize = 16;
  //   barSize = lineSize - 1;
  //   axisSize = 50;
  //   seriesSize = Math.floor((width - axisSize) / 2);
  //   height = lineSize * numberOfItems;
  // }
  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    margins = {
      top: 60,
      right: 20,
      bottom: 24,
      left: 20,
    };
    lineSize = 10;
    barSize = lineSize - 2;
    axisSize = 80;
    seriesSize = Math.floor((width - axisSize - margins.left - margins.right) / 2);
    orientation = 'vertical';
    height = (lineSize * numberOfItems) + margins.top + margins.bottom;
  }
  return {
    axisSize,
    barSize,
    height,
    lineSize,
    margins,
    orientation,
    seriesSize,
    width,
  };
};

export const keywordsList = term => {
  const list = term.split(',');
  if (list.length < 12) {
    return term;
  }
  const showing = list.slice(0, 10).join(', ');
  return `${showing}… e altre ${list.length - 10}`;
};
